var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-date-picker',{attrs:{"color":_vm.color,"is-range":_vm.isRange,"is-expanded":_vm.isExpanded},on:{"input":_vm.onSelectedDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }